var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "languageTitle"
  }, "Language") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "languageTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.467,
    x2: 13.533,
    y1: 4.667,
    y2: 4.667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.467,
    x2: 13.533,
    y1: 9.333,
    y2: 9.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61111111 0C3.93784233 4.28382563 3.93784233 9.71617437 6.61111111 14M7.38888889 0C10.0621577 4.28382563 10.0621577 9.71617437 7.38888889 14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLanguage);
export default __webpack_public_path__ + "static/media/mobile_language.e671cbfbb8f635ff9cffdd9272d69ef0.svg";
export { ForwardRef as ReactComponent };